import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const TahfidzDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Tahfidz", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Tahfidz",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className="tw-rounded-lg card-body">
          <div className="tw-text-accent-primary tw-text-xs">Bulan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {moment(state.bulan ?? Date.now()).format("MMMM YYYY")}, pekan
            {state.pekan ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Surat</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.surat ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">
            Ayat Awal - Akhir
          </div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.ayatAwal ?? "0"} - {state.ayatAkhir ?? "0"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Total Halaman</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.halaman ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Keterangan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.keterangan ?? "-"}
          </div>
        </div>
      </div>
    </>
  );
};
